import type { LoyaltyTier } from '../../../types/loyalty'

// Fixed display order — used by Members filter dropdown, Tier Distribution
// widget, and anywhere we iterate over tiers in a stable way.
export const TIER_ORDER: readonly LoyaltyTier[] = [
  'starter',
  'silver',
  'gold',
  'platinum',
] as const

export const TIER_LABEL: Record<LoyaltyTier, string> = {
  starter: 'Starter',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
}

// Mockup palette (breadstack-loyalty.html lines 86–91, 727).
// Background + foreground + chart-fill triple. Kept as literals because
// per-tier hues aren't part of @pantry/ui's brand palette.
export interface TierPalette {
  bg: string
  fg: string
  fill: string
}

export const TIER_PALETTE: Record<LoyaltyTier, TierPalette> = {
  starter: { bg: '#F3F4F6', fg: '#6B7280', fill: '#D1D5DB' },
  silver: { bg: '#F1F5F9', fg: '#475569', fill: '#94A3B8' },
  gold: { bg: '#FEF3C7', fg: '#92400E', fill: '#F59E0B' },
  platinum: { bg: '#EDE9FE', fg: '#6D28D9', fill: '#8B5CF6' },
}

// API may return 'unknown' for members below the starter threshold. We render
// them as Starter in distribution widgets to keep the visual fixed at 4 buckets.
export const normalizeTier = (
  tier: LoyaltyTier | 'unknown' | null | undefined,
): LoyaltyTier => {
  if (!tier || tier === 'unknown') return 'starter'
  return tier
}
